export const initialState = {
  selectedTimezone: null,
};
